<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" :model="filters">
        <el-form-item label="客户名称:">
          <el-select v-model="filters.company" clearable placeholder="请选择">
            <el-option
              v-for="item in companies"
              :key="item.id"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备状态:" style="margin-left: 15px;">
          <el-radio-group v-model="filters.state">
            <el-radio :label="null">全部</el-radio>
            <el-radio :label="1">正常</el-radio>
            <el-radio :label="2">预警</el-radio>
            <el-radio :label="3">告警</el-radio>
            <el-radio :label="4">故障</el-radio>
          </el-radio-group>
        </el-form-item>
        <div style="float:right">
          <el-form-item>
            <el-button type="primary" v-on:click="getDevices">查询</el-button>
            <el-button type="primary" v-on:click="handleAdd">添加</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="devices" highlight-current-row border v-loading="listLoading" :row-class-name="tableRowClassName"
              style="width: 100%;" ref="deviceTable" @row-click="rowClick">
      <el-table-column header-align="center" label="设备ID" align="center" width="160">
        <template scope="scope">
          {{scope.row.deviceId}}
        </template>
      </el-table-column>
      <el-table-column header-align="center" label="设备类型" align="center" width="100">
        <template scope="scope">
          {{!scope.row.deviceId.startsWith('9') ? '终端' : scope.row.deviceId.startsWith('91') ? '骐骏独立式探测器' : '威胜独立式探测器'}}
        </template>
      </el-table-column>
      <el-table-column header-align="center" prop="port" label="端口" width="80"
                       align="center">
      </el-table-column>
      <el-table-column header-align="center" prop="name" label="设备名称" align="center" min-width="150">
      </el-table-column>
      <el-table-column header-align="center" prop="company" label="所属客户" min-width="170" align="center">
      </el-table-column>
      <el-table-column header-align="center" prop="group" label="所属区域" min-width="120" align="center">
      </el-table-column>
      <el-table-column header-align="center" prop="location" label="设备位置" align="center" min-width="200">
      </el-table-column>
      <!--<el-table-column header-align="center" prop="autoTx" :formatter="formatTx" label="自动消谐" width="100"-->
                       <!--align="center">-->
      <!--</el-table-column>-->
      <el-table-column header-align="center" prop="createdAt" :formatter="formatTime" label="创建时间" min-width="120"
                       align="center">
      </el-table-column>
      <el-table-column header-align="center" prop="online" label="是否在线" min-width="100" align="center" fixed="left">
        <template scope="scope">
          <el-tag v-if="scope.row.online == null || !scope.row.online"
                  type="gray"
                  close-transition>{{scope.row.online | filterOnline}}
          </el-tag>
          <el-tag v-if="scope.row.online"
                  type="success"
                  close-transition>{{scope.row.online | filterOnline}}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column header-align="center" label="当前状态" width="100" align="center" fixed="left">
        <template scope="scope">
          <el-tag v-if="scope.row.disconState"
                  type="gray"
                  close-transition>断闸
          </el-tag>
          <el-tag v-if="!scope.row.disconState && scope.row.state === 1"
                  type="success"
                  close-transition>{{scope.row.state | filterState}}
          </el-tag>
          <el-tag v-if="!scope.row.disconState && scope.row.state === 2"
                  type="warning"
                  close-transition>{{scope.row.state | filterState}}
          </el-tag>
          <el-tag v-if="!scope.row.disconState && scope.row.state === 3"
                  type="danger"
                  close-transition>{{scope.row.state | filterState}}
          </el-tag>
          <el-tag v-if="!scope.row.disconState && scope.row.state === 4"
                  type="gray"
                  close-transition>{{scope.row.state | filterState}}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="启动/停止" width="100" align="center" fixed="left">
        <template scope="scope">
          <el-button size="small" type="primary" :disabled="!scope.row.online" v-if="!scope.row.start" @click.stop="handleStart(scope.$index, scope.row)">启动</el-button>
          <el-button size="small" type="danger" :disabled="!scope.row.online" v-if="scope.row.start" @click.stop="handleStop(scope.$index, scope.row)">停止</el-button>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150" align="center" fixed="right">
        <template scope="scope">
          <el-button size="small" @click.stop="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button type="danger" size="small" @click.stop="handleDel(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10" :total="total"
                     style="float:right;">
      </el-pagination>
    </el-col>

    <!--新增界面-->
    <el-dialog title="新增设备" v-model="addFormVisible" :close-on-click-modal="false">
      <el-steps :active="active" finish-status="success" :space="200" align-center center>
        <el-step title="基本信息"></el-step>
        <el-step title="采集参数"></el-step>
        <el-step title="其他配置"></el-step>
      </el-steps>
      <el-form style="margin-top:5px;" :model="addForm" label-width="120px" :rules="addFormRules" ref="addForm">
        <div v-show="active == 1">
          <el-form-item label="所属客户" prop="companyId">
            <el-select v-model="addForm.companyId" placeholder="请选择" @change="companyChange">
              <el-option
                      v-for="item in companies" :key="item.id"
                      :label="item.name"
                      :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属区域" prop="groupId">
            <el-select v-model="addForm.groupId" placeholder="请选择">
              <el-option
                      v-for="item in groups" :key="item.id"
                      :label="item.name"
                      :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="设备ID" prop="deviceId">
            <el-input v-model="addForm.deviceId" :maxlength="12"></el-input>
          </el-form-item>
          <el-form-item label="设备类型">
            <template scope="scope">
              {{addForm.deviceId && (!addForm.deviceId.startsWith('9') ? '终端' : addForm.deviceId.startsWith('91') ? '骐骏独立式探测器' : '威胜独立式探测器')}}
            </template>
          </el-form-item>
          <el-form-item label="设备名称" prop="name">
            <el-input v-model="addForm.name"></el-input>
          </el-form-item>
          <el-form-item label="设备别名" prop="alias">
            <el-input v-model="addForm.alias"></el-input>
          </el-form-item>
          <el-form-item label="设备位置" prop="location">
            <el-input v-model="addForm.location"></el-input>
          </el-form-item>
        </div>
        <div v-show="active == 2">
          <el-form-item label="采集频率(分钟):">
            <el-input-number v-model="addForm.rate" :controls="false" :min="5" :step="1" :max="45" style="width: 150px;"></el-input-number>
          </el-form-item>
          <div v-if="!addForm.deviceId.startsWith('9')">
            <el-form-item label="相线CT:">
              <el-input-number v-model="addForm.ct" :controls="false" :min="1" :max="600" :step="1" style="width: 150px;"></el-input-number>
            </el-form-item>
            <el-form-item label="零线CT:">
              <el-input-number v-model="addForm.lct" :controls="false" :min="1" :max="600" :step="1" style="width: 150px;"></el-input-number>
            </el-form-item>
            <el-form-item label="PT:">
              <el-input-number v-model="addForm.pt" :controls="false" :min="1" :max="600" :step="1" style="width: 150px;"></el-input-number>
            </el-form-item>
          </div>
          <!--<el-form-item label="通信地址" prop="deviceAddr">-->
            <!--<el-input v-model="addForm.deviceAddr"></el-input>-->
          <!--</el-form-item>-->
          <el-form-item label="断路功能" prop="canBreak">
            <el-switch
              v-model="addForm.canBreak"
              on-text="是"
              off-text="否">
            </el-switch>
          </el-form-item>
          <el-form-item label="是否启用">
            <el-switch v-model="addForm.enable" on-text="是" off-text="否">
            </el-switch>
          </el-form-item>
        </div>
        <div v-show="active == 3">
          <el-col :span="24">
            <template v-if="!addForm.deviceId.startsWith('9')">
              <el-form :inline="true" :model="paramsAddForm" :rules="paramsAddFormRules" ref="paramsAddForm">
                <el-form-item label="变量名称:" prop="paramsType">
                  <el-select v-model="paramsAddForm.paramsType" placeholder="请选择">
                    <el-option
                            v-for="item in names"
                            :key="item.type"
                            :label="item.name"
                            :value="item.type">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="预警值:" style="margin-left: 15px;">
                  <el-input-number v-model="paramsAddForm.warnUp" :min="1" :max="999"></el-input-number>
                </el-form-item>
                <div style="float:right">
                  <el-form-item>
                    <el-button type="primary" v-on:click="addFromParamsSubmit">添加</el-button>
                  </el-form-item>
                </div>
              </el-form>
            </template>
            <template v-if="addForm.deviceId.startsWith('9')">
              <el-form :inline="true" :model="paramsAddForm" :rules="paramsAddFormRules" ref="paramsAddForm">
                <el-form-item label="通道名称:" prop="channel">
                  <el-select v-if="addForm.deviceId.startsWith('91')" v-model="paramsAddForm.channel" placeholder="请选择">
                    <el-option
                            v-for="item in names3"
                            :key="item.type"
                            :label="item.name"
                            :value="item.type">
                    </el-option>
                  </el-select>
                  <el-select v-if="!addForm.deviceId.startsWith('91')" v-model="paramsAddForm.channel" placeholder="请选择">
                    <el-option
                            v-for="item in names2"
                            :key="item.type"
                            :label="item.name"
                            :value="item.type">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="通道类型:" prop="channelType">
                  <el-select v-model="paramsAddForm.channelType" placeholder="请选择">
                    <el-option
                            v-for="item in channelTypes"
                            :key="item.type"
                            :label="item.name"
                            :value="item.type">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="通道别名:" prop="channelAlias">
                  <el-input v-model="paramsAddForm.channelAlias"></el-input>
                </el-form-item>
                <el-form-item label="预警值:" style="margin-left: 15px;">
                  <el-input-number v-model="paramsAddForm.warnUp" :min="1" :max="999"></el-input-number>
                </el-form-item>
                <div style="float:right">
                  <el-form-item>
                    <el-button type="primary" v-on:click="addFromParamsSubmit">添加</el-button>
                  </el-form-item>
                </div>
              </el-form>
            </template>
          </el-col>
          <el-col :span="24">
            <el-table :data="deviceAddParams" highlight-current-row border
                      style="width: 100%;" ref="paramsTable">
              <el-table-column prop="deviceId" header-align="center" label="设备ID" align="center" width="160">
              </el-table-column>
              <el-table-column prop="device" header-align="center" align="center" label="设备名称" min-width="140">
              </el-table-column>
              <el-table-column v-if="addForm.deviceId.startsWith('9')" header-align="center" align="center"
                               label="通道名称" min-width="120">
                <template scope="scope">
                  通道{{scope.row.channel}}
                </template>
              </el-table-column>
              <el-table-column v-if="addForm.deviceId.startsWith('9')" header-align="center" align="center"
                               label="通道类型" min-width="120">
                <template scope="scope">
                  {{scope.row.channelType == 1 ? '电流': '温度'}}
                </template>
              </el-table-column>
              <el-table-column v-if="addForm.deviceId.startsWith('9')" prop="channelAlias" header-align="center" align="center"
                               label="通道别名" min-width="120">
              </el-table-column>
              <div v-if="!addForm.deviceId.startsWith('9')">
                <el-table-column prop="paramsType" :formatter="formatParamType" header-align="center" align="center"
                                 label="变量名称" min-width="120">
                </el-table-column>
              </div>
              <el-table-column header-align="center" align="center" label="预警值" width="130">
                <template scope="scope">
                  {{scope.row.warnUp}}
                </template>
              </el-table-column>
              <!--<el-table-column header-align="center" align="center" label="告警值" width="130">-->
                <!--<template scope="scope">-->
                  <!--{{scope.row.errorUp}}-->
                <!--</template>-->
              <!--</el-table-column>-->
              <el-table-column prop="createdAt" header-align="center" align="center" label="创建时间"
                               :formatter="formatTime" width="120">
              </el-table-column>
              <el-table-column label="操作" width="150" align="center">
                <template scope="scope">
                  <el-button type="danger" size="small" @click="handleDelParamsAddForm(scope.$index, scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button v-if="active == 2 || active == 3" style="margin-top: 12px;" @click="prev">上一步</el-button>
        <el-button v-if="active < 3" style="margin-top: 12px;" @click="next">下一步</el-button>
        <el-button type="primary" v-if="active == 3" @click.native="addSubmit" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog title="编辑设备" v-model="editFormVisible" :close-on-click-modal="false">
      <el-form :model="editForm" label-width="100px" :rules="editFormRules" ref="editForm">
        <el-form-item label="所属客户" prop="companyId">
          <el-select v-model="editForm.companyId" placeholder="请选择" @change="companyChange" :disabled="true">
            <el-option
              v-for="item in companies" :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属区域" prop="groupId">
          <el-select v-model="editForm.groupId" placeholder="请选择" :disabled="true">
            <el-option
              v-for="item in groups" :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备ID" prop="deviceId">
          <el-input v-model="editForm.deviceId" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="设备名称" prop="name">
          <el-input v-model="editForm.name"></el-input>
        </el-form-item>
        <el-form-item label="设备别名" prop="alias">
          <el-input v-model="editForm.alias"></el-input>
        </el-form-item>
        <el-form-item label="设备位置" prop="location">
          <el-input v-model="editForm.location"></el-input>
        </el-form-item>
        <!--<el-form-item label="通信地址" prop="deviceAddr">-->
          <!--<el-input v-model="editForm.deviceAddr"></el-input>-->
        <!--</el-form-item>-->
        <el-form-item label="断路功能" prop="canBreak">
          <el-switch
            v-model="editForm.canBreak"
            on-text="是"
            off-text="否">
          </el-switch>
        </el-form-item>
         <el-form-item label="是否启用">
          <el-switch v-model="editForm.enable" on-text="是" off-text="否">
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
      </div>
    </el-dialog>

    <el-col :span="24" v-show="paramSettingVisible">
      <el-tabs type="border-card" class="panel">
        <el-tab-pane label="通道别名与预警设置">
          <el-col :span="24">
            <template v-if="selectedRow && !selectedRow.deviceId.startsWith('9')">
              <el-form :inline="true" :model="paramsForm" :rules="paramsFormRules" ref="paramsForm">
                <el-form-item label="变量名称:" prop="paramsType">
                  <el-select v-model="paramsForm.paramsType" placeholder="请选择">
                    <el-option
                            v-for="item in names"
                            :key="item.type"
                            :label="item.name"
                            :value="item.type">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="预警值:" style="margin-left: 15px;">
                  <el-input-number v-model="paramsForm.warnUp" :min="1" :max="999"></el-input-number>
                </el-form-item>
                <div style="float:right">
                  <el-form-item>
                    <el-button type="primary" v-on:click="addParamsSubmit">添加</el-button>
                  </el-form-item>
                </div>
              </el-form>
            </template>
            <template v-if="selectedRow && selectedRow.deviceId.startsWith('9')">
              <el-form :inline="true" :model="paramsForm" :rules="paramsFormRules" ref="paramsForm">
                <el-form-item label="通道名称:" prop="channel">
                  <el-select v-if="selectedRow.deviceId.startsWith('91')" style="width:100px;" v-model="paramsForm.channel" placeholder="请选择">
                    <el-option
                            v-for="item in names3"
                            :key="item.type"
                            :label="item.name"
                            :value="item.type">
                    </el-option>
                  </el-select>
                  <el-select v-if="selectedRow && !selectedRow.deviceId.startsWith('91')" style="width:100px;" v-model="paramsForm.channel" placeholder="请选择">
                    <el-option
                            v-for="item in names2"
                            :key="item.type"
                            :label="item.name"
                            :value="item.type">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="通道类型:" prop="channelType">
                  <el-select v-model="paramsForm.channelType" style="width:100px;" placeholder="请选择">
                    <el-option
                            v-for="item in channelTypes"
                            :key="item.type"
                            :label="item.name"
                            :value="item.type">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="通道别名:" prop="channelAlias">
                  <el-input style="width:120px;" v-model="paramsForm.channelAlias"></el-input>
                </el-form-item>
                <el-form-item label="预警值:" style="margin-left: 15px;">
                  <el-input-number :controls="false" style="width:100px;" v-model="paramsForm.warnUp" :min="1" :max="999"></el-input-number>
                </el-form-item>
                <div style="float:right">
                  <el-form-item>
                    <el-button type="primary" v-on:click="addParamsSubmit">添加</el-button>
                  </el-form-item>
                </div>
              </el-form>
            </template>
          </el-col>
          <el-col :span="24">
            <el-table :data="deviceParams" highlight-current-row border v-loading="paramsListLoading"
                      style="width: 100%;" ref="paramsTable">
              <el-table-column header-align="center" label="设备ID" align="center" width="160">
                <template scope="scope">
                  {{selectedRow.deviceId}}
                </template>
              </el-table-column>
              <el-table-column prop="device" header-align="center" align="center" label="设备名称" min-width="140">
              </el-table-column>
              <el-table-column v-if="selectedRow && selectedRow.deviceId.startsWith('9')" header-align="center" align="center"
                               label="通道名称" min-width="120">
                <template scope="scope">
                  通道{{scope.row.channel}}
                </template>
              </el-table-column>
              <el-table-column v-if="selectedRow && selectedRow.deviceId.startsWith('9')" header-align="center" align="center"
                               label="通道类型" min-width="120">
                <template scope="scope">
                  {{scope.row.channelType == 1 ? '电流': '温度'}}
                </template>
              </el-table-column>
              <el-table-column v-if="selectedRow && selectedRow.deviceId.startsWith('9')" prop="channelAlias" header-align="center" align="center"
                               label="通道别名" min-width="120">
              </el-table-column>
              <div v-if="selectedRow && !selectedRow.deviceId.startsWith('9')">
                <el-table-column prop="paramsType" :formatter="formatParamType" header-align="center" align="center"
                                 label="变量名称" min-width="120">
                </el-table-column>
              </div>
              <el-table-column header-align="center" align="center" label="预警值" width="130">
                <template scope="scope">
                  {{scope.row.warnUp}}
                </template>
              </el-table-column>
              <el-table-column prop="createdAt" header-align="center" align="center" label="创建时间"
                               :formatter="formatTime" min-width="120">
              </el-table-column>
              <el-table-column label="操作" width="150" align="center">
                <template scope="scope">
                  <el-button type="danger" size="small" @click="handleDelParams(scope.$index, scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-tab-pane>
        <el-tab-pane label="参数设置">
          <el-col :span="24">
            <el-form :inline="true" :model="collectorForm" ref="collectorForm" v-loading="collectorLoading">
              <el-form-item label="采集频率(分钟):" style="margin-left: 15px;">
                <el-input-number v-model="collectorForm.rate" :controls="false" :min="5" :max="45" :step="1" style="width: 100px;"></el-input-number>
              </el-form-item>
              <template v-if="selectedRow && !selectedRow.deviceId.startsWith('9')">
                <el-form-item label="相线CT:" style="margin-left: 15px;">
                  <el-input-number v-model="collectorForm.ct" :controls="false" :min="1" :max="600" :step="1" style="width: 100px;"></el-input-number>
                </el-form-item>
                <el-form-item label="零线CT:" style="margin-left: 15px;">
                  <el-input-number v-model="collectorForm.lct" :controls="false" :min="1" :max="600" :step="1" style="width: 100px;"></el-input-number>
                </el-form-item>
                <el-form-item label="PT:" style="margin-left: 15px;">
                  <el-input-number v-model="collectorForm.pt" :controls="false" :min="1" :max="600" :step="1" style="width: 100px;"></el-input-number>
                </el-form-item>
              </template>
              <el-form-item>
                <el-button type="primary" v-on:click="saveCollectorParams">保存</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-tab-pane>
      </el-tabs>
    </el-col>
  </section>

</template>
<style>
</style>
<script>
  import {
    getCollectors,
    saveParams,
    addDevice,
    editDevice,
    getCompanyList,
    getGroupList,
    getDevicesList,
    getDevicesinfo,
    removeDevice,
    getDeviceParamList,
    addDeviceParams,
    removeDeviceParams,
    startDevice,
    stopDevice
  } from '../../api/api'

  import moment from 'moment'

  //  const uuidv4 = require('uuid/v4');

  export default{
    data(){
      var validateWordAndNumberAndChinese = (rule, value, callback) => {
        var jgpattern = /^[\u4e00-\u9fa5_（）\(\)a-zA-Z0-9]+$/;
        if (!jgpattern.test(value)) {
          callback(new Error('请输入中文、字母、数字、圆括号或下划线'));
        } else {
          callback();
        }
      };
      var validateNumber = (rule, value, callback) => {
        var jgpattern = /^[+0-9]+$/;
        if (!jgpattern.test(value)) {
          callback(new Error('请输入数字'));
        } else {
          callback();
        }
      };
      var validateLength12 = (rule, value, callback) => {
        if (value.length != 12) {
          callback(new Error('长度必须是12位'));
        } else {
          callback();
        }
      };
      return {
        selectedRow: {
          deviceId: ''
        },
        devices: [],
        companies: [],
        groups: [],
        listLoading: false,
        page: 1,
        total: 5,
        active: 1,
        filters: {
          company: '',
          state: null
        },
        names: [
//          {name: 'A相正向有功电能', type: 1},
//          {name: 'B相正向有功电能', type: 2},
//          {name: 'C相正向有功电能', type: 3},
//          {name: '总正向有功电能', type: 4},
          {name: '第1路温度', type: 5},
          {name: '第2路温度', type: 6},
          {name: '第3路温度', type: 7},
          {name: '第4路温度', type: 8},
//          {name: 'A相电压', type: 9},
//          {name: 'B相电压', type: 10},
//          {name: 'C相电压', type: 11},
          {name: 'A相电流', type: 12},
          {name: 'B相电流', type: 13},
          {name: 'C相电流', type: 14},
          {name: '零线电流', type: 15},
//          {name: 'A相有功功率', type: 16},
//          {name: 'B相有功功率', type: 17},
//          {name: 'C相有功功率', type: 18},
//          {name: '总有功功率', type: 19},
//          {name: 'A相功率因素', type: 20},
//          {name: 'B相功率因素', type: 21},
//          {name: 'C相功率因素', type: 22},
//          {name: '总功率因素', type: 23},
//          {name: '电压不平衡度', type: 24},
//          {name: '电流不平衡度', type: 25},
//          {name: 'A相无功功率', type: 26},
//          {name: 'B相无功功率', type: 27},
//          {name: 'C相无功功率', type: 28},
//          {name: '总无功功率', type: 29},
//          {name: '频率', type: 30},
//          {name: 'A相3次谐波电流', type: 35},
//          {name: 'B相3次谐波电流', type: 36},
//          {name: 'C相3次谐波电流', type: 37},
        ],
        names1: [
          {name: '第1路剩余电流', type: 101},
          {name: '第2路剩余电流', type: 102},
          {name: '第3路剩余电流', type: 103},
          {name: '第4路剩余电流', type: 104},
          {name: '第5路剩余电流', type: 105},
          {name: '第6路剩余电流', type: 106},
          {name: '第7路剩余电流', type: 107},
          {name: '第8路剩余电流', type: 108},
          {name: '第1路温度', type: 201},
          {name: '第2路温度', type: 202},
          {name: '第3路温度', type: 203},
          {name: '第4路温度', type: 204},
          {name: '第5路温度', type: 205},
          {name: '第6路温度', type: 206},
          {name: '第7路温度', type: 207},
          {name: '第8路温度', type: 208}
        ],
        names2: [
          {name: '通道1', type: 1},
          {name: '通道2', type: 2},
          {name: '通道3', type: 3},
          {name: '通道4', type: 4},
          {name: '通道5', type: 5},
          {name: '通道6', type: 6},
          {name: '通道7', type: 7},
          {name: '通道8', type: 8},
        ],
        names3: [
          {name: '通道1', type: 1},
          {name: '通道2', type: 2},
          {name: '通道3', type: 3},
          {name: '通道4', type: 4},
        ],
        channelTypes: [
          {name: '电流', type: 1},
          {name: '温度', type: 2},
        ],
        menuHeight: '761px',
        addFormVisible: false,//新增界面是否显示
        addLoading: false,
        addFormRules: {
          name: [
            {required: true, message: '请输入设备名称', trigger: 'blur'},
            {validator: validateWordAndNumberAndChinese, trigger: 'blur'}
          ],
          alias: [
            {required: true, message: '请输入设备别名', trigger: 'blur'},
            {validator: validateWordAndNumberAndChinese, trigger: 'blur'}
          ],
          companyId: [
            {required: true, message: '请选择所属客户', trigger: 'change'}
          ],
          groupId: [
            {required: true, message: '请选择所属区域', trigger: 'change'}
          ],
          location: [
            {required: true, message: '请输入设备地址', trigger: 'blur'},
            {validator: validateWordAndNumberAndChinese, trigger: 'blur'}
          ],
          deviceAddr: [
            {required: true, message: '请输入通信地址', trigger: 'blur'},
            {validator: validateNumber, trigger: 'blur'}
          ],
          deviceId: [
            {required: true, message: '请输入设备ID', trigger: 'blur'},
            {validator: validateNumber, trigger: 'blur'},
            {validator: validateLength12, trigger: 'blur'}
          ],
        },
        //新增界面数据
        addForm: {
          deviceId: '',
          name: '',
          alias: '',
          companyId: '',
          groupId: '',
          location: '',
          deviceAddr: '',
          autoTx: false,
          rate: 15,
          ct: 1,
          lct: 1,
          pt: 1, 
          canBreak:false,
          enable: false
        },
        collectorForm: {
          id: '',
          rate: 15,
          ct: 1,
          lct: 1,
          pt: 1
        },
        paramsFormRules: {
          paramsType: [
            {required: true, message: '请选择变量名称'},
          ],
          channel: [
            {required: true, message: '请选择通道名称'},
          ],
          channelType: [
            {required: true, message: '请选择通道类型'},
          ],
          channelAlias: [
            {required: true, message: '请输入通道别名'},
          ],
        },
        paramsAddForm: {
          channel: 1,
          channelType: 1,
          channelAlias: '',
          warnUp: 1
        },
        paramsAddFormRules: {
          channel: [
            {required: true, message: '请选择通道名称'},
          ],
          channelType: [
            {required: true, message: '请选择通道类型'},
          ],
          channelAlias: [
            {required: true, message: '请输入通道别名'},
          ],
          warnType: [
            {required: true, message: '请输入预警阈值'},
          ],
        },
        collectorLoading: false,
        tempCompanyId: '',
        editFormVisible: false,//新增界面是否显示
        editLoading: false,
        editFormRules: {
          name: [
            {required: true, message: '请输入设备名称', trigger: 'blur'},
            {validator: validateWordAndNumberAndChinese, trigger: 'blur'}
          ],
          alias: [
            {required: true, message: '请输入设备别名', trigger: 'blur'},
            {validator: validateWordAndNumberAndChinese, trigger: 'blur'}
          ],
          companyId: [
            {required: true, message: '请选择所属客户', trigger: 'change'}
          ],
          groupId: [
            {required: true, message: '请选择所属区域', trigger: 'change'}
          ],
          location: [
            {required: true, message: '请输入设备地址', trigger: 'blur'},
            {validator: validateWordAndNumberAndChinese, trigger: 'blur'}
          ],
          deviceAddr: [
            {required: true, message: '请输入通信地址', trigger: 'blur'},
            {validator: validateNumber, trigger: 'blur'}
          ]
        },
        //新增界面数据
        editForm: {
          id: '',
          deviceId: '',
          name: '',
          alias: '',
          companyId: '',
          groupId: '',
          location: '',
          deviceAddr: '',
          autoTx: false,
          rate: 15,
          ct: 1,
          lct: 1,
          pt: 1,
          canBreak:false,
          enable:false
        },
        paramSettingVisible: false,
        paramsForm: {
          paramsType: null,
          channel: 1,
          channelType: 1,
          channelAlias: '',
          warnUp: 1,
        },
        deviceParams: [],
        deviceAddParams: [],
        paramsListLoading: false
      }
    },
    filters: {
      filterState(state) {
        switch (state) {
          case 1:
            return '正常';
          case 2:
            return '预警';
          case 3:
            return '告警';
          case 4:
            return '故障';
          case 5:
            return '断闸';
          default:
            return '正常';
        }
      },
      filterOnline(state) {
        return state ? '在线' : '离线';
      },
    },
    methods: {
      formatParamType(row, column) {
        if (!row.paramsType) return;
        if (row.deviceId.toUpperCase().startsWith("9")) {
          var tt = this.names1.filter(t => {
            return t.type == row.paramsType;
          });
          return tt[0].name;
        } else {
          //row.paramsType
          console.log(this.names)
          var tt = this.names.filter(t => {
            return t.type == row.paramsType;
          });
//          console.log(tt);
          return tt[0].name;
        }

      },
      tableRowClassName(row, index) {
        return 'rowClass';
      },
      getDevices() {
        let para = {
          page: this.page,
          size: 10,
          name: this.filters.company,
          state: this.filters.state
        };
        this.listLoading = true;
        //NProgress.start();
        getDevicesinfo(para).then((res) => {
          this.total = res.data.total;
          this.devices = res.data.list;
          this.listLoading = false;
          this.paramSettingVisible = false;
          //NProgress.done();
        });
      },
      formatTx: function (row, column) {
        return (row.autoTx == 1 || row.autoTx) ? '是' : '否';
      },
      formatTime: function (row, column) {
        return moment(row.createdAt).format('YYYY-MM-DD');
      },
      handleCurrentChange(val) {
        this.page = val;
        this.getDevices();
      },
      rowClick: function (row, event, column) {
        this.selectedRow = row;
        if (row.deviceId.toUpperCase().startsWith("9")) {
          this.paramsForm = {
            paramsType: null,
            channel: 1,
            channelType: 1,
            channelAlias: '',
            warnUp: 1,
          };
          this.names = [
            {name: '第1路剩余电流', type: 101},
            {name: '第2路剩余电流', type: 102},
            {name: '第3路剩余电流', type: 103},
            {name: '第4路剩余电流', type: 104},
            {name: '第5路剩余电流', type: 105},
            {name: '第6路剩余电流', type: 106},
            {name: '第7路剩余电流', type: 107},
            {name: '第8路剩余电流', type: 108},
            {name: '第1路温度', type: 201},
            {name: '第2路温度', type: 202},
            {name: '第3路温度', type: 203},
            {name: '第4路温度', type: 204},
            {name: '第5路温度', type: 205},
            {name: '第6路温度', type: 206},
            {name: '第7路温度', type: 207},
            {name: '第8路温度', type: 208}
            ]
        } else {
          this.names = [
//            {name: 'A相正向有功电能', type: 1},
//            {name: 'B相正向有功电能', type: 2},
//            {name: 'C相正向有功电能', type: 3},
//            {name: '总正向有功电能', type: 4},
            {name: '第1路温度', type: 5},
            {name: '第2路温度', type: 6},
            {name: '第3路温度', type: 7},
            {name: '第4路温度', type: 8},
//            {name: 'A相电压', type: 9},
//            {name: 'B相电压', type: 10},
//            {name: 'C相电压', type: 11},
            {name: 'A相电流', type: 12},
            {name: 'B相电流', type: 13},
            {name: 'C相电流', type: 14},
            {name: '零线电流', type: 15},
//            {name: 'A相有功功率', type: 16},
//            {name: 'B相有功功率', type: 17},
//            {name: 'C相有功功率', type: 18},
//            {name: '总有功功率', type: 19},
//            {name: 'A相功率因素', type: 20},
//            {name: 'B相功率因素', type: 21},
//            {name: 'C相功率因素', type: 22},
//            {name: '总功率因素', type: 23},
//            {name: '电压不平衡度', type: 24},
//            {name: '电流不平衡度', type: 25},
//            {name: 'A相无功功率', type: 26},
//            {name: 'B相无功功率', type: 27},
//            {name: 'C相无功功率', type: 28},
//            {name: '总无功功率', type: 29},
//            {name: '频率', type: 30},
//            {name: 'A相3次谐波电流', type: 35},
//            {name: 'B相3次谐波电流', type: 36},
//            {name: 'C相3次谐波电流', type: 37},
          ]
        };

        this.paramSettingVisible = true;
        this.getParams();
        this.getCollectorParams();
      },
      next() {
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            if (this.active++ > 2) this.active = 3;
          }
        });
      },
      prev() {
        if (this.active-- < 1) this.active = 1;
      },
      //获取企业列表
      getCompanies() {
        let para = {
          name: ''
        };
        //NProgress.start();
        getCompanyList(para).then((res) => {
          this.companies = res.data.list;
          //NProgress.done();
        });
      },
      //获取变量列表
      getParams() {
        let para = {
          deviceId: this.selectedRow.id
        };
        this.paramsListLoading = true;
        //NProgress.start();
        getDeviceParamList(para).then((res) => {
          this.paramsListLoading = false;
          this.deviceParams = res.data;
          console.log(this.deviceParams)
          //NProgress.done();
        });
      },
      //获取变量列表
      getCollectorParams() {
        //NProgress.start();
        this.collectorLoading = true;
        getCollectors(this.selectedRow.id).then((res) => {
          this.collectorLoading = false;
          this.collectorForm.id = res.data.id;
          this.collectorForm.rate = res.data.rate;
          this.collectorForm.ct = res.data.ct;
          this.collectorForm.lct = res.data.lct;
          this.collectorForm.pt = res.data.pt;
          //NProgress.done();
        });
      },
      //获取企业列表
      getGroups(company) {
        let para = {
          companyId: company
        };
        //NProgress.start();
        getGroupList(para).then((res) => {
          this.groups = res.data.list;
          //NProgress.done();
        });
      },
      //显示新增界面
      handleAdd: function () {
        this.addFormVisible = true;
        this.active = 1;
        if (this.$refs['addForm']) {
          this.$refs['addForm'].resetFields();
        }
        this.deviceAddParams = [];
        this.paramsAddForm = {
          channel: 1,
          channelType: 1,
          channelAlias: '',
          warnUp: 1
        };
        this.addForm = {
          deviceId: '',
          name: '',
          alias: '',
          companyId: '',
          groupId: '',
          location: '',
          deviceAddr: '',
          rate: 15,
          ct: 1,
          lct: 1,
          pt: 1,
          canBreak: false
        };
      },
      //新增
      addSubmit: function () {
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.addLoading = true;
              //NProgress.start();
              let para = Object.assign({}, this.addForm);
              para.deviceParams = this.deviceAddParams;
              addDevice(para).then((res) => {
                this.addLoading = false;
                if (res.code == 400) {
                  this.$message({
                    message: res.message,
                    type: 'error'
                  });
                  return;
                }
                //NProgress.done();
                this.$message({
                  message: '提交成功',
                  type: 'success'
                });
                this.$refs['addForm'].resetFields();
                this.addFormVisible = false;
                this.getDevices();
              });
            });
          }
        });
      },
      addParamsSubmit: function () {
        this.$refs.paramsForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              //NProgress.start();
              let para = Object.assign({}, this.paramsForm);
              para.deviceId = this.selectedRow.id;
              addDeviceParams(para).then((res) => {
                //NProgress.done();
                this.$message({
                  message: '提交成功',
                  type: 'success'
                });
                this.$refs['paramsForm'].resetFields();
                this.getParams();
              });
            });
          }
        });
      },
      addFromParamsSubmit: function () {
        this.$refs.paramsAddForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              //NProgress.start();
              let para = Object.assign({}, this.paramsAddForm);
              let p = {
                deviceId: this.addForm.deviceId,
                device: this.addForm.name,
                paramsType: para.paramsType,
                warnUp: para.warnUp,
                channel: para.channel,
                channelType: para.channelType,
                channelAlias: para.channelAlias
              };
              this.deviceAddParams.push(p);
            });
          }
        });
      },
      //显示编辑界面
      handleEdit: function (index, row) {
        if (this.$refs['editForm']) {
          this.$refs['editForm'].resetFields();
        }
        this.tempCompanyId = row.companyId;
        this.getGroups(row.companyId);
        this.editForm = Object.assign({}, row);
        this.editFormVisible = true;
      },
      //编辑
      editSubmit: function () {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.editLoading = true;
              let para = {
                id: this.editForm.id,
                name: this.editForm.name,
                alias: this.editForm.alias,
                companyId: this.editForm.companyId,
                groupId: this.editForm.groupId,
                location: this.editForm.location,
                deviceAddr: this.editForm.deviceAddr,
                canBreak: this.editForm.canBreak,
                enable:this.editForm.enable
              };
              editDevice(para).then((res) => {
                this.editLoading = false;
                //NProgress.done();
                this.$message({
                  message: '提交成功',
                  type: 'success'
                });
                this.$refs['editForm'].resetFields();
                this.editFormVisible = false;
                this.getDevices();
              });
            });
          }
        });
      },
      //删除
      handleDel: function (index, row) {
        this.$confirm('确认删除该记录吗?', '提示', {
          type: 'warning'
        }).then(() => {
          this.listLoading = true;
          //NProgress.start();
          removeDevice(row.id).then((res) => {
            this.listLoading = false;
            //NProgress.done();
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.getDevices();
          });
        }).catch(() => {

        });
      },
      handleStart: function (index, row) {
        this.$confirm('确认启动该设备吗?', '提示', {
          type: 'warning'
        }).then(() => {
          startDevice({
            id: row.id,
            deviceId: row.deviceId,
            port: row.port,
          }).then((res) => {
            //NProgress.done();
            if (res.code == 400) {
              this.$message({
                message: res.message,
                type: 'error'
              });
              return;
            }
            this.$message({
              message: '启动成功',
              type: 'success'
            });
            this.getDevices();
          });
        }).catch(() => {

        });
      },
      handleStop: function (index, row) {
        this.$confirm('确认停止该设备吗?', '提示', {
          type: 'warning'
        }).then(() => {
          stopDevice({
            deviceId: row.deviceId,
            port: row.port,
          }).then((res) => {
            if (res.code == 400) {
              this.$message({
                message: res.message,
                type: 'error'
              });
              return;
            }
            //NProgress.done();
            this.$message({
              message: '停止成功',
              type: 'success'
            });
            this.getDevices();
          });
        }).catch(() => {

        });
      },
      handleDelParams: function (index, row) {
        this.$confirm('确认删除该记录吗?', '提示', {
          type: 'warning'
        }).then(() => {
          this.paramsListLoading = true;
          //NProgress.start();
          removeDeviceParams(row.id).then((res) => {
            this.paramsListLoading = false;
            //NProgress.done();
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.getParams();
          });
        }).catch(() => {

        });
      },
      handleDelParamsAddForm: function (index, row) {
        this.$confirm('确认删除该记录吗?', '提示', {
          type: 'warning'
        }).then(() => {
          this.deviceAddParams.pop();
        }).catch(() => {

        });
      },
      saveCollectorParams() {
        this.$refs.collectorForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              //NProgress.start();
              let para = Object.assign({}, this.collectorForm);
              console.log(this.selectedRow)
              para.deviceId = this.selectedRow.id;
              saveParams(para).then((res) => {
                //NProgress.done();
                this.$message({
                  message: '提交成功',
                  type: 'success'
                });
                this.getDevices();
              });
            });
          }
        });
      },
      companyChange: function (val) {
        if (val != this.tempCompanyId) {
          this.addForm.groupId = '';
          this.editForm.groupId = '';
        }
        this.getGroups(val);
      }
    },
    components: {},
    mounted: function () {
      this.getDevices();
      this.getCompanies();
    }
  }
</script>



// WEBPACK FOOTER //
// Device.vue?58f807b2